/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PolicyDefaultException } from '../models/PolicyDefaultException';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PolicyDefaultExceptionService {

    /**
     * List the company's policy default exceptions, ordered by position
     * @returns PolicyDefaultException Success
     * @throws ApiError
     */
    public static listPolicyDefaultExceptions(): CancelablePromise<Array<PolicyDefaultException>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/policyDefaultException',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
